import { z } from 'zod';

/**
 * Client-side environment variables
 * These are baked into the bundle at build time and available via import.meta.env
 */
export const clientSchema = {
  // Soniox Configuration
  VITE_SONIOX_RT_MODEL: z.string().min(1),

  // Convex configuration
  VITE_CONVEX_URL: z.url(),

  VITE_REVIEW_ACCOUNT_EMAIL: z.email(),
  VITE_SITE_URL: z.url(),

  // RevenueCat Configuration
  VITE_RC_TEST_API_KEY: z.string().min(1).optional(),
  VITE_RC_PUBLIC_GOOGLE_API_KEY: z.string().min(1).optional(),
  VITE_RC_PUBLIC_IOS_API_KEY: z.string().min(1).optional(),
  VITE_RC_PUBLIC_WEB_API_KEY: z.string().min(1).optional(),

  // PDF Viewer Configuration
  VITE_PUBLIC_REACT_PDF_LICENSE_KEY: z.string().min(1),

  // Sentry Configuration
  VITE_SENTRY_DSN: z.url().optional(),

  // Apple
  VITE_APPLE_CLIENT_ID: z.string().min(1),
};

/**
 * Build-time environment variables
 * These are validated when vite.config.ts loads
 */
export const buildSchema = {
  // Convex configuration
  VITE_CONVEX_URL: z.url().optional(),

  VITE_REVIEW_ACCOUNT_EMAIL: z.email(),

  VITE_SERVER_URL: z.url().optional(),
  VITE_SITE_URL: z.url(),

  // Comma separated list of allowed hosts for dev server
  VITE_ALLOWED_HOSTS: z
    .string()
    .optional()
    .transform((val) =>
      val ? val.split(',').map((host) => host.trim()) : undefined,
    ),
};
